<template>
  <div class="content-item flex" v-if="categoryDrugs.length > 0">
    <div class="content-item-label"><span class="red">*</span>药品分类</div>
    <el-radio-group v-model="index" class="flex align-items-center" @change="$emit('checkCateGoryLabel', categoryDrugs, index)">
      <el-radio v-for="(item, index) in categoryDrugs" :key="index" :label="index" >{{ item.name }}</el-radio>
    </el-radio-group>
  </div>
</template>

<script>
import {request} from "@/utils/axios";
export default {
  name: "CategoryDrugs",
  props: ['functionIds'],
  data () {
    return {
      categoryDrugs: [],
      index: '',
    }
  },
  methods: {
    queryDrugCategoryWithRel(contentId) {
      return new Promise((resolve,reject) => {
        if (this.categoryDrugs.length == 0) {
          request(this.functionIds.queryDrugCategoryWithRel,{
            tenantId: this.$commonJs.getTenantId(),
            contentId,
          }).then(res => {
            this.categoryDrugs = res || [];
            this.categoryDrugs.forEach((item, index) => {
              item.checked && (this.index = index)
            });
            resolve(this.categoryDrugs);
          }).catch(err => {
            reject(err)
          })
        } else {
          resolve(this.categoryDrugs);
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
